<template>
  <el-autocomplete
    ref="ac"
    popper-class="el-select-table"
    :value="label"
    :fetch-suggestions="refresh"
    :placeholder="placeholder"
    :size="size"
    :clearable="clearable"
    :value-key="labelField"
    style="width:100%"
    @select="select"
    @input="input"
    @change="change"
  >
    <template v-if="columns" slot-scope="{ item }">
      <span v-for="col in columns" :key="col.prop" :title="item[col.prop]" :style="cellStyle">
        {{ item[col.prop] }}
      </span>
    </template>
  </el-autocomplete>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'changeVal'
  },
  props: {
    value: [Number, String, Array],
    valueField: String,
    labelField: String,
    url: String,
    placeholder: String,
    size: String,
    extraParam: Object,
    searchKey: {
      type: String,
      default: 'numberOrName'
    },
    selFirst: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    label: String,

    columns: Array,
    panelWidth: [Number, String]
  },
  data: function() {
    return {
      selItem: null
    }
  },
  computed: {
    cellStyle: function() {
      var colCount = this.columns.length || 1
      return {
        width: `${100 / colCount}%`
      }
    }
  },
  watch: {
  },
  mounted: function() {
    if (this.selFirst) {
      this.refresh().then(items => {
        if (items && items.length > 0) {
          this.changeSelItem(items[0])
        }
      })
    }
  },
  methods: {
    changePanelWidth: function() {
      var dropDownList = this.$refs.ac.$children[1].$el
      dropDownList.style.width = this.panelWidth
    },
    changeSelItem: function(item) {
      this.selItem = item
      if (item) {
        this.$emit('changeVal', item[this.valueField])
        this.$emit('change', item)
      } else {
        this.$emit('changeVal', null)
        this.$emit('change', null)
      }

      this.changeLabel(item ? item[this.labelField] : null)
    },
    changeLabel: function(val) {
      this.$emit('update:label', val)
    },

    input: function(val) {
      this.changeLabel(val)
    },
    change: function(val) {
      // if(this.$refs.ac.activated) return;

      if (!val) {
        this.changeSelItem(null)
        return
      }

      if (this.selItem) {
        var preLabel = this.selItem[this.labelField]
        if (preLabel != val) {
          this.changeLabel(preLabel)
        }
      } else {
        this.changeLabel(null)
      }
    },
    select: function(item) {
      this.changeSelItem(item)
    },
    refresh: function(query, cb) {
      var postData = { }
      postData[this.searchKey] = query
      Object.assign(postData, this.extraParam)

      return this.$httpPost(this.url, postData).then(res => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
        }
        this.changePanelWidth()
        var items = res.datalist || []
        if (cb) cb(items)
        return items
      })
    }
  }
}
</script>

<style lang="less">
  .el-select-table {
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
